
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-minimap-demo-plugin-minimap"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.zh.md?type=demo')
};